// Publishes a "generate_lead" custom event to Shopify's analytics bus (Customer events) when a visitor taps WhatsApp or a phone link.
// A custom pixel subscribed to "generate_lead" forwards it to GA4; without one this is a harmless no-op.
document.addEventListener('click', function (event) {
  var link = event.target.closest && event.target.closest('a[href]');
  var analytics = window.Shopify && window.Shopify.analytics;
  if (!link || !analytics || typeof analytics.publish !== 'function') return;
  var href = link.getAttribute('href') || '';
  var method = /^https?:\/\/(wa\.me|api\.whatsapp\.com)\//.test(href) ? 'whatsapp' : href.indexOf('tel:') === 0 ? 'phone' : '';
  if (!method) return;
  var name = document.querySelector('alnashir-product .apx-title');
  analytics.publish('generate_lead', {
    method: method,
    page_path: location.pathname,
    item_name: name ? name.textContent.trim() : undefined
  });
});
